import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCsDefuse = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 8.33322L0.564644 8.76282C0.564644 8.76282 4.06636 5.19292 9.78296 5.01221C9.78296 5.01221 9.2448 3.83526 9.72339 3.34277C9.72339 3.34277 8.85358 4.19537 6.94783 4.48795C5.09238 4.77259 2.43532 5.3935 0 8.33322Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.33626 15.4321C7.46269 15.583 7.69437 15.585 7.82345 15.4361C8.47613 14.6808 10.0933 13.063 10.415 11.6504C10.7254 10.2881 11.3464 8.19829 11.4688 7.31392C11.5774 6.52819 11.8501 5.50216 12.3393 4.95539C12.6233 4.63832 12.8536 3.98299 12.6444 3.6123C12.6239 3.57655 12.6014 3.5408 12.5756 3.50506C12.5233 3.43291 12.4995 3.34421 12.516 3.25683C12.606 2.78486 12.9291 1.27495 13.4984 0.549451C13.5983 0.422357 13.5917 0.242306 13.4772 0.127789L13.448 0.0986632C13.3262 -0.0231357 13.1409 -0.032403 13.0131 0.0721852C12.5107 0.483918 11.3444 1.55893 11.1848 2.78949C11.1736 2.87819 11.1259 2.95895 11.0518 3.00926C10.8406 3.15356 10.4216 3.513 10.4104 4.10545C10.4011 4.59 10.5196 4.81374 10.6129 4.91501C10.6791 4.9865 10.7135 5.0805 10.7036 5.17781C10.6162 6.02047 10.1032 9.46526 9.78216 10.4562C9.37573 11.7119 9.33071 13.3291 7.37465 14.9833C7.24027 15.0965 7.22373 15.2977 7.33626 15.4321Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2949 3.34269C13.2949 3.34269 13.5948 4.40181 13.3896 4.84598L13.9344 4.60436C14.3176 4.43424 14.6599 4.18403 14.9372 3.8696L16.0003 2.6675L15.6534 2.16772C15.6534 2.16839 14.9332 3.16926 13.2949 3.34269Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("defs", {})
	]
});
export default SvgCsDefuse;
